export default "__VITE_ASSET__DSHcbJlg__"